export default "__VITE_ASSET__ZPWZvnqt__"